import type { DummyFoods } from './dummyFoods'

export const driedHerb: DummyFoods = {
  'Dried herb': {
    Basil: ['Dried basil'],
    Oregano: ['Dried oregano'],
    Parsley: ['Dried parsley'],
    Rosemary: ['Dried rosemary'],
    Tarragon: ['Dried tarragon'],
  },
}
